// Prismic requirement for generating links
const linkResolver = doc => {
  if (doc.type === "timeline_node") {
    return `/timeline/${doc.uid}`;
  }

  if (doc.type === "event") {
    return `/events/${doc.uid}`;
  }

  if (doc.type === "events") {
    return `/events`;
  }

  if (doc.type === "post") {
    return `/get-involved/${doc.uid}`;
  }

  if (doc.type === "initiative") {
    return `/initiatives/${doc.uid}`;
  }

  if (doc.type === "impact") {
    return `/impact/${doc.uid}`;
  }

  if (doc.type === "impact_listing") {
    return `/impact`;
  }

  if (doc.type === "listing_page") {
    return `/${doc.uid}`;
  }

  if (doc.type === "home") {
    return `/`;
  }

  if (doc.type === "vision") {
    return `/vision`;
  }
};

module.exports = {
  linkResolver
};
